import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Smartphone } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';

export function MobileInstallBanner() {
  const { isInstalled } = usePWA();
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile
    const checkMobile = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      setIsMobile(/iphone|ipad|ipod|android/.test(userAgent));
    };
    checkMobile();

    // Check if banner was dismissed
    const wasDismissed = localStorage.getItem('mobile-install-banner-dismissed');
    const dismissedAt = wasDismissed ? parseInt(wasDismissed, 10) : 0;
    const daysSinceDismissed = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);

    // Show banner if: mobile, not installed, and not dismissed in last 7 days
    if (!wasDismissed || daysSinceDismissed > 7) {
      // Delay showing the banner to not interrupt initial page load
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('mobile-install-banner-dismissed', Date.now().toString());
  };

  // Don't show if: not mobile, already installed, or dismissed
  if (!isMobile || isInstalled || !isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-4 right-4 z-50 animate-in slide-in-from-bottom-4 duration-300">
      <div className="bg-primary text-primary-foreground rounded-lg shadow-lg p-3 flex items-center gap-3">
        <div className="flex-shrink-0">
          <Smartphone className="h-6 w-6" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">Install Sentinel Crop</p>
          <p className="text-xs opacity-90">Quick access & offline mode</p>
        </div>
        <Link
          to="/install"
          onClick={handleDismiss}
          className="flex-shrink-0 bg-white text-primary px-3 py-1.5 rounded-md text-sm font-medium hover:bg-white/90 transition-colors"
        >
          Install
        </Link>
        <button
          onClick={handleDismiss}
          className="flex-shrink-0 p-1 hover:bg-white/20 rounded-full transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
